// extracted by mini-css-extract-plugin
export default {"button":"Favorite_button__fIIdk","active":"Favorite_active__DsbVt"};